<template>
<div class="user-update update-form container row">
  <h2>{{ $t('models.user.edit_user') }}</h2>
  <form class="user-update--form col-xs-12 col-sm-12 col-md-6 col-lg-6" @submit.prevent="update">
    <field :errors="errors" name="firstname" label="models.user.firstname" v-model="item.firstname" placeholder="Andy"></field>
    <field :errors="errors" name="lastname" label="models.user.lastname" v-model="item.lastname" placeholder="Kaufman"></field>
    <field :errors="errors" :readonly="true" name="email" label="models.user.email" v-model="item.email" placeholder="andykaufman@googlemail.com"></field>
    <field v-if="item.role == 'admin'" :errors="errors" v-can="'organization.list'" name="organization" label="Organization" v-model="item.organization_id" type="select" :params="{'no_i18n':true}" :collection="organizations"></field>
    <user-status-select v-can="'users.update_status'" :errors="errors" name="status" label="models.user.status" v-model="item.status"></user-status-select>
    <user-role-select v-can="'users.update_role'" :errors="errors" name="roles" label="models.user.role" v-model="item.role"></user-role-select>
    <div class="update-form--actions">
      <button class="btn btn-tertiary" @click.prevent="cancel">{{ $t('ui.global.cancel') }}</button>
      <button class="btn btn-primary btn-save" type="submit">{{ $t('ui.global.save') }}</button>
    </div>
  </form>
</div>
</template>
<script>
import Api from '@/api/User.js'
import OrganizationApi from '@/api/Organization.js'
import UserStatusSelect from '@/components/helpers/Specific/UserStatusSelect'
import UserRoleSelect from '@/components/helpers/Specific/UserRoleSelect'
import Permission from '@/classes/Permission'
import {updateMixin} from '@/components/mixins/Update'
import Ui from '@/classes/Ui'



export default {
  mixins: [updateMixin],
  components: { UserStatusSelect, UserRoleSelect},
  data(){
    return {
      model: "users",
      api: new Api(),
      organizations: [],
    }
  },
  methods: {
    retrieve_organizations(){
      let permission = Permission.loadPermissions()

      if (Permission.can(permission, 'organizations.list')) {
        let api = new OrganizationApi()
        api.all_for_association('name').then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.log(error.response)
        })
      }
    }
  },
  mounted() {
    Ui.clearHeaderButtons()
    this.retrieve_organizations()
  },

}
</script>
<style lang="scss">
.update-form--actions {
  margin-top: 1em;
  text-align: right;
  .btn-tertiary {
    margin-right: 1em;
  }
}

.user-update--form {
  .field-radio, .field-checkbox {
    margin-top: 1em !important;
  }
  .field--radio, .field--checkbox {
    margin-top: .8em !important;
  }
  label, .text-label {
    font-size: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// UserUpdate.vue?01282fe0